module.exports = __webpack_public_path__ + "img/judcom_logo.25ed85ac.png";